<template src="./measure_units.html">
</template>

<script>
import {API_URL} from '@/main'
import axios from "axios"
import router from '@/router/index.js'

export default {
  name: "MeasureUnits",
  data() {
    return {
      alertMsg: '',
      current_id: null,
      currentPage: 1,
      form_data: {
        id: null,
        measure_unit: '',
      },
      measure_units: [],
      paginatedUM: [],
      perPage: 10,
      selectedUm: {},      
      showAlert: false,
      showModal: false,      
      total_rows: 0,
    }
  },
  watch: {
    currentPage: {
      handler(newPage, oldPage) {

        console.log(`Page changed from ${oldPage} to ${newPage}`) /**/
        this.updatePaginatedUM()
      }
    },
    perPage: {
      handler() {

        this.currentPage = 1
        this.updatePaginatedUM()
      }
    },    
  },   
  mounted() {

    this.loadUMsList()
  },
  methods: {
    cancelUM() {

      this.current_id = null
      this.form_data = {
        id: null,
        measure_unit: '',
      }
    },
    async deleteRecord(id) {

      this.id2Delete = id
      this.showModal = true
    },    
    editRow(measure_unit) {

      if(!measure_unit || !measure_unit.measure_unit) {

        console.error("measure_unit is not defined in the selected row")
        return
      }
      this.current_id = measure_unit.id
      this.form_data = {
        id: measure_unit.id,
        measure_unit: measure_unit.measure_unit,
      }
    },
    async handleDelete() {

      try {
      
        const url = API_URL + "various/MeasureUnitsDetail/" + this.id2Delete + "/"
        const headers = {
          'User-ID': localStorage.getItem('User_id'),
          'token': localStorage.getItem('Token'),
        }
        const response = await axios.delete(url, {headers})
        this.showModal = false
        this.current_id = null
        await this.loadUMsList()
      } 
      catch (error) {
      
        console.debug("handleDelete() error", error.response)
        if(error.response.status == 500) {
          
          this.alertMsg = "Attenzione! L'unità di misura risulta essere utilizzata da almeno una riga di listino. Per rimuoverlo di devono prima rimuovere tutte le righe di listino che utilizzano questa base"
          this.showAlert = true
        }
      }
    },
    handlePageChange(page) {
      
      this.currentPage = page
      this.$nextTick(() => {
      
        this.loadUMsList()
      })
    },    
    async insertUM() {
      
      const url = API_URL + "various/MeasureUnitsDetail/"
      const headers = {
        'User-ID': localStorage.getItem('User_id'),
        'token': localStorage.getItem('Token'),
      }
      const response = await axios.post(url, this.form_data, {headers})
      console.debug("2. insertUM()", response)
      this.cancelUM()
      this.loadUMsList()
    },
    async loadUMsList() {
    
      const url = API_URL + "various/MeasureUnitsList/"
      const axiosInstance = axios.create({
        headers: {
          'User-ID': localStorage.getItem('User_id'),
          'token': localStorage.getItem('Token'),
        },
      })
    
      try {
    
        const response = await axiosInstance.get(url)
        this.measure_units = response.data.map(measure_unit => ({
    
          id: measure_unit.id,
          measure_unit: measure_unit.measure_unit,
        }))
    
        this.total_rows = this.measure_units.length // Update total_rows
        this.updatePaginatedUM()
      } 
      catch (error) {
      
        console.log('Failed to load measure_units list:', error)
      }
    },
    onPageChange(page) {
  
      console.debug("onPageChange() called with page:", page) /**/
      this.currentPage = page
      this.updatePaginatedUM()
    },
    onSortChanged(ctx) {
      
      this.sortBy = ctx.sortBy
      this.sortDesc = ctx.sortDesc
    },    
    async selectUM(row) {
      
      this.current_id = row.id
      const url = API_URL + "various/MeasureUnitsDetail/" + row.id + "/"
      const headers = {
        'User-ID': localStorage.getItem('User_id'),
        'token': localStorage.getItem('Token'),
      }
      const response = await axios.get(url, {headers: headers})
      this.form_data = response.data
    },    
    async updateUM() {
      
      const url = API_URL + "various/MeasureUnitsDetail/" + this.current_id + "/"
      const headers = {
        'User-ID': localStorage.getItem('User_id'),
        'token': localStorage.getItem('Token'),
      }
      const response = await axios.patch(url, this.form_data, {headers})
      this.cancelUM()
      this.loadUMsList()
    },
    async updatePaginatedUM() {
    
      console.debug("updatePaginatedUM() called") /**/
      const start = (this.currentPage - 1) * this.perPage
      const end = start + this.perPage
      this.paginatedUM = this.measure_units.slice(start, end)
      console.debug("Recalculated paginatedUM:", this.paginatedUM) /**/
      this.$forceUpdate()
    },
  },
}
</script>
